import { Box } from '@mui/material'
import { HeroSection } from './hero-section'
import { TimelineSection } from './timeline-section'
import { RoadmapSection } from './roadmap-section'
import { DataProtectionSection } from './data-protection-section'
import { PageSeo } from '../page-seo'

const ABOUT_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'TerraPlanner',
  url: 'https://terra-planner.com',
  description: 'Climate-aware crop scheduling tool built for everyday farmers and homesteaders.',
  contactPoint: { '@type': 'ContactPoint', email: 'admin@terra-planner.com', contactType: 'customer support' },
}

export const About = () => {
  return (
    <Box>
      <PageSeo
        title="About"
        description="TerraPlanner is a climate-aware crop scheduling tool built for everyday farmers and homesteaders — combining real frost data, seasonal rhythms, and your crops into one living plan."
        path="/about"
        schema={ABOUT_SCHEMA}
      />
      <HeroSection />
      <TimelineSection />
      <RoadmapSection />
      <DataProtectionSection />
    </Box>
  )
}
